import { motion } from "framer-motion";
import { BeforeAfter } from "./BeforeAfter";

const Card = ({ src, label, accent, aspect, delay, testId }) => (
  <motion.div
    data-testid={testId}
    initial={{ y: 24 }}
    whileInView={{ y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] }}
    className={`group relative ${aspect} rounded-2xl overflow-hidden ring-1 ${accent ? "ring-[#d5d9df]/40 shadow-[0_30px_90px_-30px_rgba(190,197,208,0.8)]" : "ring-white/10"} bg-black`}
  >
    <img src={src} alt={label} loading="lazy" draggable={false} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
    <span className={`absolute top-3 left-3 pill-label ${accent ? "!bg-white !text-[#050505]" : ""}`}>{label}</span>
  </motion.div>
);

export const MediaPair = ({ before, after, label = "Background Swap", portrait = false, wide = false, testId = "media-pair" }) => {
  const aspect = portrait ? "aspect-[3/4]" : wide ? "aspect-[4/3]" : "aspect-square";
  return (
    <div data-testid={testId}>
      <div className="hidden md:grid grid-cols-2 gap-3 lg:gap-4">
        <Card src={before} label="Original" aspect={aspect} delay={0} testId={`${testId}-original`} />
        <Card src={after} label={label} aspect={aspect} delay={0.12} accent testId={`${testId}-after`} />
      </div>
      <div className="md:hidden">
        <BeforeAfter before={before} after={after} alt={label} labels={["Original", label]} testId={`${testId}-slider`}
          className={`relative ${portrait ? "aspect-[3/4]" : "aspect-[4/3]"} rounded-2xl ring-1 ring-white/10`} />
        <p className="mt-2 text-xs text-slate-400 text-center">Drag to compare</p>
      </div>
    </div>
  );
};
